import { getGraphqlClient } from "@/api/graphql/client.ts";

import { getMiddleMsGetIngestionSnapshotQuery } from "./queries";

export const getMigrationStatus = async () =>
  await getGraphqlClient().request(getMiddleMsGetIngestionSnapshotQuery);
